import { News } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const publishedReducer: RemoteReducer<News[]> =
  createRemoteReducer("published")
